import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {

  getUsageAreas: () => {
    return axios.get(`${deployPath}/api/vehicles/usageAreas`)
      .then(usageAreas => {
        return usageAreas.data.Data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getCarBrands: (codSubramo, isSOA) => {
    return axios.get(`${deployPath}/api/vehicles/carBrands/${codSubramo}/${isSOA}`)
      .then(carBrands => {
        return carBrands.data.Data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getCarYears: (carBrandCode, codSubramo) => {
    return axios.get(`${deployPath}/api/vehicles/carYears/${carBrandCode}/${codSubramo}`)
      .then(carYears => {
        return carYears.data.Data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getCarModels: (carBrandCode, carYearCode, codSubramo, codTipoVehiculo) => {
    return axios.get(`${deployPath}/api/vehicles/carModels/${carBrandCode}/${carYearCode}/${codSubramo}/${codTipoVehiculo}`)
      .then(carModels => {
        return carModels.data.Data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  getQuotation: (carBrandCode, carYearCode, carModelCode, carUsageAreaCode, codSubramo, codUso, codManejo) => {
    return axios.get(`${deployPath}/api/vehicles/quotation/${carBrandCode}/${carYearCode}/${carModelCode}/${carUsageAreaCode}/${codSubramo}/${codUso}/${codManejo}`)
      .then(quotation => {
        return quotation.data.Data;
      })
      .catch(error => {
        // console.log(error);
      });
  }
};
